export default {"src":"/_next/static/media/error.c6ab287e.svg","height":600,"width":600};